export const dailyValues: { [index: string]: number } = {
  fat: 78,
  fat_saturated: 20,
  cholesterol: 300,
  carbohydrate: 275,
  fiber: 28,
  sugar: 50,
  added_sugar: 50,
  sodium: 2300,
  calcium: 1300,
  iron: 18,
  vitamin_c: 90,
  vitamin_a_IU: 900,
  potassium: 4700,
  magnesium: 420,
  phosphorus: 1250,
  zinc: 11,
  copper: 0.9,
  manganese: 2.3,
  selenium: 55,
  thiamin: 1.2,
  riboflavin: 1.3,
  niacin: 16,
  vitamin_b6: 1.7,
  folate: 400,
  vitamin_b12: 2.4,
  vitamin_e: 15,
  vitamin_d_IU: 20,
  vitamin_k: 120
};

export const calculateDailyPercentage = (key: string, value: number) => Math.round((value / dailyValues[key]) * 100);
